import gql from 'graphql-tag';

import getIncreaseHitsMutationField from './getIncreaseHitsMutationField';

const getIncreaseHitsMutation = (prefix, hasLocalNews) => (hasLocalNews
  ? gql`
    mutation increaseHits($id: Int!) {
      ${getIncreaseHitsMutationField(prefix, hasLocalNews)}(
        id: $id
      )
    }
  `
  : gql`
    mutation increaseHits($id: Int!, $newsboard: Newsboard!) {
      ${getIncreaseHitsMutationField(prefix, hasLocalNews)}(
        id: $id,
        newsboard: $newsboard
      )
    }
  `
);

export default getIncreaseHitsMutation;
